<template>
    <div class="card-section page-header">
        <!-- <button class="btn-back" @click="$router.go(-1)">
        <i class="mdi mdi-arrow-left"></i>
      </button> -->
        <h2 class="product-title">
            {{ $t(title) }}
        </h2>
    </div>
</template>

<script>

export default {
    name: "PageTitle",
    props: {
        title: { type: String, default: '?', required: true },
    },
    data() {
        return {
        };
    },
};
</script>

<style scoped>
/* HEADER */
.page-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    gap: 1rem;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
}

.product-title {
    font-weight: bold;
    font-size: 1.1rem;
    color: black;
}

@media (max-width: 767px) {
    .page-header {
        margin-top: 0.9rem;
        margin-bottom: 0.6rem;
    }


}
</style>